export enum V3DropdownCTAColor {
    color = "color",
    red = "red"
}
